import router from '@/router'
import store from '@/store'
import { snsLogin, getUserInfo } from '@/http/api/account'

var index = {
  initContext: function () {
    router.push({ path: '/login' })
  },
  callbackLogin: function (loginInfo) {
    if (typeof loginInfo !== 'object') {
      loginInfo = JSON.parse(loginInfo)
    }
    if (loginInfo !== '' && loginInfo !== null) {
      snsLogin(loginInfo.id).then(tokenResponse => {
        getUserInfo(tokenResponse.accessToken).then(userResponse => {
          store.dispatch('setToken', tokenResponse.accessToken)
          store.dispatch('setId', userResponse.id)
          store.dispatch('setName', userResponse.name)
          store.dispatch('setUsername', userResponse.username)

          router.push({ name: 'home' })
        }).catch(function(error) {
          console.log(error)
        })
      }).catch(function(error) {
        console.log(error)
        if (error.response.data.status === 401) {
          router.push({ name: 'sns', params: { id: loginInfo.id, name: loginInfo.name, email: loginInfo.email, type: loginInfo.type } })
        }
      })
    }
  },
  callbackLogout: function () {
    //
  }
}

window.bridge = index



// WEBPACK FOOTER //
// ./src/utils/bridge.js